export default __webpack_public_path__ + "static/media/icon_login.ca28c937.png";